var exports = {
  "uW": "section___IM8Eh",
  "wx": "header__H_OPz7",
  "DD": "title__zhOv0_",
  "h_": "description__G3aviG",
  "p_": "list__D59e4X",
  "AS": "item__0vThpv",
};

module.exports = exports;
